// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"882":"617c1453","930":"f994093d"}[chunkId] + ".chunk.js";
};